module.exports = __webpack_public_path__ + "img/tSql.78c5f5f4.svg";